// extracted by mini-css-extract-plugin
export default {"touchArea":"TouchArea_touchArea__uOO9F","md":"TouchArea_md__3KN4D","lg":"TouchArea_lg__9e1WP"};